import Page from "@/components/pages/inventory/vendor/page";
import { createFileRoute } from "@tanstack/react-router";
import { withRouteProtection } from "@/lib/router/route-protection";
import { PROTECTION_PRESETS } from "@/lib/router/protection-presets";

export const Route = createFileRoute("/_app/inventory/vendor/")({
	component: Page,
	// ...withRouteProtection(PROTECTION_PRESETS.AUTHENTICATED),
});
